import React from 'react'
import PlusSales from '../components/dashboard/PlusSales'

const PlusSalesPage = () => <PlusSales />

export default PlusSalesPage
